import { render } from "./DriveoffDetails.vue?vue&type=template&id=6a393966&scoped=true"
import script from "./DriveoffDetails.vue?vue&type=script&lang=js"
export * from "./DriveoffDetails.vue?vue&type=script&lang=js"

import "./DriveoffDetails.vue?vue&type=style&index=0&id=6a393966&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a393966"]])

export default __exports__